export default __webpack_public_path__ + "static/media/posologia.7d078051.png";